import { AnyAction, Dispatch, MiddlewareAPI } from 'redux';
import { LocalStorageKeyName } from 'enums/LocalStorageKeyName';
import { Environments, getEnvironment } from 'utils/getEnvironment';
import { LOGOUT_ACTION_TYPE } from 'handlers';
import { setYourIncomeData } from 'handlers/yourIncome';
import { setYourBirthDateData } from 'handlers/yourBirthDate';
import { setYourSSN4 } from 'handlers/yourSSN4';
import { setResendState } from 'handlers/yourContact';

const BORROWER_ACTION_TYPES = [
  setYourIncomeData.type,
  setYourBirthDateData.type,
  setYourSSN4.type,
  setResendState.type,
];
const WHITELISTED_ACTION_TYPES = [LOGOUT_ACTION_TYPE, ...BORROWER_ACTION_TYPES];

const saveApplicationDataMiddleware = ({ getState }: MiddlewareAPI) => (next: Dispatch<AnyAction>) => (
  action: AnyAction,
) => {
  const result = next(action);

  if (
    WHITELISTED_ACTION_TYPES.includes(action.type) ||
    (!action.type.startsWith('location') && (action.type.endsWith('fulfilled') || action.type.endsWith('rejected')))
  ) {
    if (getEnvironment() === Environments.Staging) {
      console.debug('Saving application data', action.type, getState());
    }

    localStorage.setItem(LocalStorageKeyName.ApplicationState, JSON.stringify(getState()));
  }

  return result;
};

export default saveApplicationDataMiddleware;
